/* global swal  angular*/
import './style.less';

import { merge } from 'lodash';
import moment from 'moment-timezone';

export default function($log, TimeZoneClass) {
  'ngInject';

  const vm = this;
  const userGuessedTimeZoneId = moment.tz.guess();

  vm.$onInit = activate;
  vm.activate = activate;
  vm.timeZoneList = TimeZoneClass.selectList;

  const emptyLocation = {
    location: '',
    capacity: '',
    googlePlaceId: '',
    lat: null,
    lng: null,
    timeZoneId: userGuessedTimeZoneId
  };

  /**
   * Takes the settings from the new location inputs, validates them, adds it to the locations array, and clears out the settings.
   */
  vm.addLocation = () => {
    const newLocation = angular.copy(vm.newLocation);

    if (!newLocation.location) {
      return swal('Error', 'Please enter a location');
    }

    if (!newLocation.capacity && newLocation.capacity != 0) {
      return swal('Error', 'Please enter a capacity');
    }

    if (vm.locations.map(({ location }) => location).includes(newLocation.location)) {
      return swal('Error', 'Please enter an unqiue location');
    }

    vm.locations.push(newLocation);

    merge(vm.newLocation, emptyLocation);
  };

  vm.removeLocation = index => {
    if (vm.locations[index].attendees && vm.locations[index].attendees.length)
      return swal(
        '',
        'All existing registrations for this location must be moved or removed before this location can be deleted.',
        'warning'
      );
    if (vm.locations[index].waitlist && vm.locations[index].waitlist.length)
      return swal(
        '',
        'All existing waitlist registrations for this location must be moved or removed before this location can be deleted.',
        'warning'
      );
    vm.locations.splice(index, 1);
  };

  /**
   * Applies the autocomplete values from the googleplace autocomplete. Does a check to see which input is being used.
   *
   * @param {Object} locationObj - Object with our location interface
   * @param {Function} applyModel - invokes an update of the view once the model is updated.
   */
  vm.autocompleteLocation = ({ googleLocationDescription, googlePlaceId, lat, lng, timeZoneId }, applyModel) => {
    if (vm.primaryLocationHasFocus) {
      vm.primaryLocation = googleLocationDescription;
      vm.primaryGooglePlaceId = googlePlaceId;
      vm.primaryLat = lat;
      vm.primaryLng = lng;
      if (timeZoneId != null) {
        vm.primaryTimeZoneId = timeZoneId;
      }
    } else {
      vm.newLocation.location = googleLocationDescription;
      vm.newLocation.googlePlaceId = googlePlaceId;
      vm.newLocation.lat = lat;
      vm.newLocation.lng = lng;
      if (timeZoneId != null) {
        vm.newLocation.timeZoneId = timeZoneId;
      }
    }
    applyModel();
  };

  /**
   * Tells us which location auto-complete has focus. Because the directives are in the same scope we end up with the same instance
   * of the directive. Pretty hacky, and probably calls for a rethink of how this is all set up.
   *
   * @param {Boolean} isPrimary - whether the primary field has focus
   */
  vm.autocompleteLocationIsPrimary = isPrimary => {
    vm.primaryLocationHasFocus = isPrimary;
  };

  function activate() {
    $log.debug('Location Editor Component Activated');
    vm.primaryTimeZoneId = vm.primaryTimeZoneId || userGuessedTimeZoneId;
    vm.newLocation = { timeZoneId: userGuessedTimeZoneId };
    vm.locations = vm.locations || [{ primary: true, timeZoneId: userGuessedTimeZoneId }];
    vm.waitlist = vm.waitlist || 'automatic';
    vm.error = false;
    vm.loaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/locationEditor/controller.js